// KaziPeople Web (Work Browser) API client — bookmarks, tenant policy, and
// server-authoritative URL classification. Reuses the shared gateway axios
// instance (cookie auth + silent refresh) from hrApi.
import { gatewayApi } from './hrApi';
import type { Bookmark, BrowserPolicy, UrlClassification } from '@/features/web/lib/types';

const B = '/api/v1/web';

export const listBookmarks = () =>
  gatewayApi.get<Bookmark[]>(`${B}/bookmarks`).then((r) => r.data);

export const listAllBookmarks = () =>
  gatewayApi.get<Bookmark[]>(`${B}/bookmarks/manage`).then((r) => r.data);

export const createBookmark = (body: Partial<Bookmark>) =>
  gatewayApi.post<Bookmark>(`${B}/bookmarks`, body).then((r) => r.data);

export const updateBookmark = (id: string, body: Partial<Bookmark>) =>
  gatewayApi.patch<Bookmark>(`${B}/bookmarks/${id}`, body).then((r) => r.data);

export const deleteBookmark = (id: string) =>
  gatewayApi.delete(`${B}/bookmarks/${id}`).then((r) => r.data);

export const getPolicy = () =>
  gatewayApi.get<BrowserPolicy>(`${B}/policy`).then((r) => r.data);

export const updatePolicy = (body: Partial<BrowserPolicy>) =>
  gatewayApi.put<BrowserPolicy>(`${B}/policy`, body).then((r) => r.data);

// Server-authoritative classification (the client mirror in urlPolicy.ts is for
// instant UX only; confirm here before trusting a capability decision).
export const validateUrl = (url: string) =>
  gatewayApi.post<UrlClassification>(`${B}/validate-url`, { url }).then((r) => r.data);

// ── Cross-domain actions (orchestration — the browser calls the OWNING domain) ──
// Attach an external link to a work item (work-management-service owns the rule).
export const attachLinkToWorkItem = (workItemId: string, name: string, url: string) =>
  gatewayApi.post(`/api/v1/work-items/${workItemId}/assets/link`, { name, url }).then((r) => r.data);
